"use client";

import { track } from "@vercel/analytics";
import { MdEmail as Email } from "react-icons/md";

import AnimatedLink from "components/animated-link";

const ContactLink = ({ email }: { email: string }) => {
  return (
    <AnimatedLink
      className="text-link order-3 mb-4 mt-3 block space-x-2 lg:text-lg"
      href={`mailto:${email}`}
      onClick={() => {
        track(`Contact e-mail`, { location: `page` });
      }}
    >
      <Email className="inline-flex text-2xl" />
      <span>{email}</span>
    </AnimatedLink>
  );
};

export default ContactLink;
